import React, { useMemo } from 'react'
import { TRouteName } from 'AppTypes'
import { withRouter } from 'react-router-dom'

// import { store } from '@utils/configStore'
import { injectStoreManagement } from '@store/storeManagementStore'
import { injectUserStoreManagement } from '@store/userStoreManagementStore'
import { injectInvoiceManagement } from '@store/invoiceManagementStore'
import { injectAnimeSubscriptionStore } from '@features/anime-subscription-management/state_management'
import { injectArticleManagementStore } from '@store/articleManagementStore'
import { injectChargeManagement } from '@store/chargeManagement'
import { injectCustomer } from '@store/customerManagement'
import { injectAffiliateManagement } from '@features/affiliate-management/state_management'
import { injectAdministratorManagement } from '@features/administrator-management/state_management'
import { injectVideoReport } from '@features/video-report/state_management'
import { injectStoreRecommendationManagement } from '@features/store-recommendation/state_management'
import { injectCustomerQuestion } from '@features/customer-question/state_management'
import { injectMarks } from '@features/marks/state_management'
import { injectStoreMarks } from '@features/store-marks/state_management'
import { injectNotificationManagementStore } from '@store/notificationManagementStore'
import { injectAmbassadorManagementStore } from '@store/ambassadorManagementStore'
import { injectOPTIntrductionVideoServiceStore } from '@features/opt/IntroductionVideo/state_management'
import { injectOPTInitialSetupServiceStore } from '@features/opt/InitialSetup/state_management'
import { injectUserProfileStore } from '@features/userprofile/state_management'
import { injectWebNotificationManagementStore } from '@store/webNotificationManagementStore'
import { injectSettingManagementStore } from '@features/setting-management/state_management'
import { injectBannerNotificationManagementStore } from '@store/bannerNotificationManagementStore'
import { injectAppBannerManagementStore } from '@features/appBanner-management/state_management'
import { injectPageSetupManagementStore } from '@features/pageSetup-management/state_management'
/**
 * Inject the reducer to the route what it's need
 * @param param0
 * @returns
 */
export const InjectReducer = withRouter(({ children, history }) => {
  const { pathname } = history.location

  return useMemo(() => {
    let inject = injectStoreManagement

    switch (pathname as TRouteName) {
      case '/':
      case '/store-list':
      case '/store-approval':
      case '/store-details':
        break
      case '/manager-list':
      case '/manager-details':
        inject = injectUserStoreManagement
        break
      case '/invoice-management':
        inject = injectInvoiceManagement
        break
      case '/video-premium-list':
      case '/video-premium-details':
      case '/video-premium-create':
        inject = injectAnimeSubscriptionStore
        break
      case '/support-video':
        inject = injectVideoReport
        break
      case '/article-list':
      case '/article-details':
        inject = injectArticleManagementStore
        break
      case '/notification-list':
      case '/notification-upsert':
        inject = injectNotificationManagementStore
        break
      case '/webnotification-list':
      case '/webnotification-upsert':
        inject = injectWebNotificationManagementStore
        break
      case '/charge-management':
      case '/gmbchargeList':
        inject = injectChargeManagement
        break
      case '/user-list':
      case '/user-details':
      case '/user-points':
        inject = injectCustomer
        break
      case '/affiliate-list':
      case '/affiliate-details':
        inject = injectAffiliateManagement
        break
      case '/administrator-list':
      case '/administrator-details':
      case '/administrator-new':
        inject = injectAdministratorManagement
        break
      case '/store-recommendation':
      case '/recommendations':
        inject = injectStoreRecommendationManagement
        break
      case '/user-question':
        inject = injectCustomerQuestion
        break
      case '/marks':
      case '/mark-details':
        inject = injectMarks
        break
      case '/store-marks':
      case '/store-marks-details':
        inject = injectStoreMarks
        break
      case '/introductionvideoservice-management':
      case '/introductionvideoservice-detail':
        inject = injectOPTIntrductionVideoServiceStore
        break
      case '/initialsetupservice-management':
      case '/initialsetupservice-detail':
        inject = injectOPTInitialSetupServiceStore
        break
      case '/ambassador-list':
        inject = injectAmbassadorManagementStore
        break
      case '/user-profile':
        inject = injectUserProfileStore
        break
      case '/livervideo-pointperperiod-setting':
        inject = injectSettingManagementStore
        break
      case '/bannernotification-list':
      case '/bannernotification-upsert':
        inject = injectBannerNotificationManagementStore
        break
      case '/topappbanner-list':
      case '/topappbanner-upsert':
      case '/bottomappbanner-list':
      case '/bottomappbanner-upsert':
        inject = injectAppBannerManagementStore
        break
      case '/pagesetup-list':
      case '/pagesetup/fixedscreen':
      case '/pagesetup/userlist':
      case '/pagesetup/liversvideolist':
        inject = injectPageSetupManagementStore
        break
      default:
        break
    }

    // reset asyncReducers before inject another reducer
    // store.asyncReducers = {}
    inject()

    return <>{children}</>
  }, [pathname, children])
})
